import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { withTheme } from 'react-jss'
import classNames from 'classnames'
import ReactCodeInput from 'react-verification-code-input'

import FormInput from 'components/form/form-input'

import formStyles from 'components/form/form-style'
import styles from './verification-code-input-style'
import { isInputWithError } from 'helpers/form'

const inputClassNames = (formClasses, inputClasses, meta) => {
  return classNames(
    inputClasses.verificationCode,
    { [formClasses.inputWithError]: isInputWithError(meta) }
  )
}

const VerificationCodeInput = props => {
  const formClasses = formStyles(props.theme)
  const inputClasses = styles(props.theme)

  return (
    <Field name={props.name}>
      {({ input, meta }) => (
        <FormInput label={props.label} meta={meta} input={input}>
          <ReactCodeInput type='text' onChange={input.onChange} className={inputClassNames(formClasses, inputClasses, meta)} fields={props.codeLength} />
          {props.children}
        </FormInput>
      )}
    </Field>
  )
}

VerificationCodeInput.propTypes = {
  name: PropTypes.string.isRequired,
  codeLength: PropTypes.number,
  label: PropTypes.string,
  children: PropTypes.node
}

VerificationCodeInput.defaultProps = {
  codeLength: 4
}

export default withTheme(VerificationCodeInput)
